import axios from 'axios';

const INITIAL_STATE = {
  posts: [],
  post: {},
  status: '',
  error: '',
};

function postReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'GET-ALL-POST': {
      return {
        ...state,
        posts: action.payload,
        error: '',
      };
    }
    case 'GET-ONE-POST': {
      return {
        ...state,
        post: action.payload,
        error: '',
      };
    }
    case 'CREATE-POST': {
      const newPostsArray = [...state.posts];
      newPostsArray.unshift(action.payload);
      return {
        ...state,
        posts: newPostsArray,
        status: 'Post créé',
        error: '',
      };
    }
    case 'POST-MODIFICATION': {
      const newPostsArray = [...state.posts];
      const postIndex = newPostsArray.findIndex(
        (post) => post.idPOSTS === action.payload.idPOSTS
      );
      const newPost = { ...newPostsArray[postIndex], ...action.payload };
      newPostsArray[postIndex] = newPost;
      return {
        ...state,
        posts: newPostsArray,
        post: newPost,
        error: '',
      };
    }
    case 'POST-DELETE': {
      const newPostsArray = [...state.posts];
      const postIndex = newPostsArray.findIndex(
        (post) => post.idPOSTS === action.payload
      );
      newPostsArray.splice(postIndex, 1);
      return {
        ...state,
        post: {},
        posts: newPostsArray,
        status: 'Post supprimé',
        error: '',
      };
    }
    case 'POST-LIKE': {
      const newPostsArray = [...state.posts];
      const postIndex = newPostsArray.findIndex(
        (post) => post.idPOSTS === action.postId
      );
      newPostsArray[postIndex].Likes = action.payload;
      const newPost = { ...newPostsArray[postIndex] };
      newPost.Likes = action.payload;
      return {
        ...state,
        posts: newPostsArray,
        post: newPost,
        status: 'like effectué',
        error: '',
      };
    }
    case 'MODIFY-POST-USER-DATA': {
      const modifiedUser = {
        nickname: action.payload.nickname,
        idUSER: action.payload.idUSER,
        pictureUrl: action.payload.pictureUrl,
      };
      const newPostsArray = [...state.posts];
      const modifiedArray = newPostsArray.map((post) => {
        if (post.user.idUSER === action.payload.idUSER) {
          post.user = modifiedUser;
          return post;
        }
        return post;
      });
      return {
        ...state,
        posts: modifiedArray,
        status: '',
        error: '',
      };
    }
    case 'POST-CLEAN-STATUS': {
      return {
        ...state,
        status: '',
      };
    }
    case 'POST-ERROR': {
      return {
        ...state,
        error: action.payload,
      };
    }
    case 'CLEAN-ERROR': {
      return {
        ...state,
        error: '',
      };
    }
    default:
      return state;
  }
}

export default postReducer;

//----------------------------------------------LocalStorage
const getLocalStorage = () => {
  if (localStorage.getItem('groupomaniaSession')) {
    return JSON.parse(localStorage.getItem('groupomaniaSession'));
  } else {
    return [];
  }
};

export const getAllPostsFunction = () => (dispatch) => {
  const session = getLocalStorage();
  axios
    .get(`${process.env.REACT_APP_API_URL}api/post/all`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      dispatch({
        type: 'GET-ALL-POST',
        payload: response.data,
      });
    })
    .catch((e) => {
      const error = e.response.data;
      if (error.message) {
        dispatch({
          type: 'POST-ERROR',
          payload: error.message,
        });
      } else {
        dispatch({
          type: 'POST-ERROR',
          payload: error,
        });
      }
    });
};

export const createAPostFunction = (post, file) => (dispatch) => {
  const session = getLocalStorage();
  const data = new FormData();
  if (!post.title) {
    data.append('title', null);
  } else {
    data.append('title', post.title);
  }
  data.append('content', post.content);
  data.append('image', file);

  axios
    .post(`${process.env.REACT_APP_API_URL}api/post/create`, data, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: 'CREATE-POST',
          payload: response.data,
        });
      }, 300);
    })
    .catch((e) => {
      const error = e.response.data.error;
      if (error.errors) {
        dispatch({
          type: 'POST-ERROR',
          payload: error.errors[0].message,
        });
      } else {
        dispatch({
          type: 'POST-ERROR',
          payload: error,
        });
      }
    });
};

export const getOnePostFunction = (id) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .get(`${process.env.REACT_APP_API_URL}api/post/${id}`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      dispatch({
        type: 'GET-ONE-POST',
        payload: response.data,
      });
    });
};

export const postModificationFunction = (post, file, id) => (dispatch) => {
  const session = getLocalStorage();
  const data = new FormData();
  data.append('title', post.title);
  data.append('content', post.content);
  data.append('image', file);
  axios
    .put(`${process.env.REACT_APP_API_URL}api/post/${id}`, data, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: 'POST-MODIFICATION',
          payload: response.data,
        });
      }, 300);
    })
    .catch((e) => {
      const error = e.response.data;
      if (error.errors) {
        dispatch({
          type: 'POST-ERROR',
          payload: error.errors[0].message,
        });
      } else {
        dispatch({
          type: 'POST-ERROR',
          payload: error,
        });
      }
    });
};

export const deletePostFunction = (id) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .delete(`${process.env.REACT_APP_API_URL}api/post/${id}`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then(() => {
      dispatch({
        type: 'POST-DELETE',
        payload: parseInt(id),
      });
    })
    .catch((e) => {
      const error = e.response.data;
      if (error.errors) {
        dispatch({
          type: 'POST-ERROR',
          payload: error.errors[0].message,
        });
      } else {
        dispatch({
          type: 'POST-ERROR',
          payload: error,
        });
      }
    });
};

export const likeFunction = (likeValue, id, userId) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .post(
      `${process.env.REACT_APP_API_URL}api/post/like/${id}`,
      { likeValue },
      {
        params: { userId: session.idUSER },
        headers: { Authorization: session.token },
      }
    )
    .then(() => {
      axios
        .get(`${process.env.REACT_APP_API_URL}api/post/like/${id}`, {
          params: { userId: session.idUSER },
          headers: { Authorization: session.token },
        })
        .then((response) => {
          dispatch({
            type: 'POST-LIKE',
            payload: response.data,
            postId: id,
          });
        })
        .catch();
    })
    .catch();
};

export const deletePostImageFunction = (id) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .delete(`${process.env.REACT_APP_API_URL}api/post/image/${id}`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      dispatch({
        type: 'POST-MODIFICATION',
        payload: response.data,
      });
    })
    .catch((e) => {
      const error = e.response.data;
      if (error.errors) {
        if (
          error.errors[0].message ===
          'Veuillez ajouter un texte ou ajouter une image'
        ) {
          dispatch({
            type: 'POST-ERROR',
            payload:
              "Impossible de supprimer l'image sans ajouter de texte au préalable",
          });
        }
      } else {
        dispatch({
          type: 'POST-ERROR',
          payload: error,
        });
      }
    });
};

export const ModifyUserDataOnPosts = (userData) => (dispatch) => {
  dispatch({
    type: 'MODIFY-POST-USER-DATA',
    payload: userData,
  });
};
